export default __webpack_public_path__ + "static/media/linkedin.cf616111.svg";